import {
  computed,
  useRoute,
  useRouter,
  useStore
} from '@nuxtjs/composition-api'
import { toCamelCase } from 'fe-common'
import { useDayjs } from '../plugins/dayjs'
import useComp from './useComp'

export default function useLocale() {
  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const dayjs = useDayjs()

  const locales = computed(() => store.state.locales)
  const locale = computed(() => store.state.locale)
  const langForDatePicker = computed(() => {
    if (locale.value === 'zh') {
      return 'zh-cn'
    }
    return [
      'en',
      'es',
      'pt-br',
      'fr',
      'ru',
      'de',
      'it',
      'cs',
      'ja',
      'vi',
      'ko',
      'pt'
    ].find(lang => locale.value === lang)
  })

  function switchLocale(locale) {
    dayjs.locale(locale)
    const location = {
      path: route.value.path + '/' + locale,
      query: route.value.query
    }
    router.push(location)
  }

  const isMobile = computed(() => store.state.isMobile)
  const { isDev } = useComp()

  function getGamePicPath(game, isDiffDevice = false) {
    let path

    // 遊戲圖片參數邏輯 改為
    // 1.全站預設參數 n-old_gamethumb
    // 2.全站如有圖片改新參數為  n-old_gamethumb-v2
    // 3.全站台 真人 參數都是 n-old_gamethumb 不能加上 v2
    // 4.全站台 柏青哥 皆不放參數
    const platforms = [
      'SPX',
      'PG',
      'HB',
      'CQ9',
      'JILI',
      'WF',
      'AUX',
      'AMEBA',
      'JDB',
      'EXP',
      'FG',
      'BNG',
      'JW',
      'NT',
      'BETSOFT',
      'VPO',
      'BTG',
      'SP',
      'IDM',
      'BRCT',
      'SM',
      'HRG',
      'MT',
      'RG',
      'HS',
      'NLC',
      'MP',
      'OP',
      'TK'
    ]
    const gamethumbParam =
      game.gameCategory !== 'PACHINKO'
        ? !platforms.includes(game.platform) || game.gameCategory === 'LIVE'
          ? '?tr=n-old_gamethumb'
          : '?tr=n-old_gamethumb_v2'
        : ''
    if (
      game.hasOwnProperty('picUrls') &&
      game.picUrls &&
      game.picUrls.length > 0
    ) {
      const filterLocale = game.picUrls
        .map(picUrl => picUrl.language)
        .includes(locale.value)
        ? locale.value
        : 'en'
      path = `${
        game.picUrls.find(picUrl => filterLocale === picUrl.language)?.url
      }${gamethumbParam}`
    }
    if (!path) {
      path = `https://ik.imagekit.io/1pzxddx3qqv/gameassert/games/${
        locale.value
      }/${isDiffDevice ? (!isMobile ? 'mobile' : 'pc') : 'pc'}/${
        game.pic
      }${gamethumbParam}`
      if (isDev.value) console.log(path)
    }
    return path
  }

  return {
    locales,
    locale,
    langForDatePicker,

    switchLocale,
    toCamelCase,
    getGamePicPath
  }
}
